<script>
import { HorizontalBar } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import merge from 'lodash/merge'

export default {
  extends: HorizontalBar,
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    xLabel: {
      type: String,
      default: '',
    },
    yLabel: {
      type: String,
      default: '',
    },
    barLabel: {
      type: Boolean,
      default: false,
    },
    unitLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    referenceDatasets() {
      return this.datasets.filter((dataset) => dataset.type === 'line')
    },
    computedData() {
      const datasets = this.datasets
        .filter((dataset) => dataset.type !== 'line')
        .map((dataset) => {
          const barDataset = { ...dataset }
          delete barDataset.type
          return barDataset
        })

      return {
        labels: this.labels,
        datasets,
        ...this.data,
      }
    },
    computedOptions() {
      const defaultOptions = {
        plugins: {
          datalabels: {
            color: 'black',
            display: true,
            font: {
              weight: 'bold',
            },
            formatter: (value) => (this.unitLabel ? `${value} ${this.unitLabel}` : value),
          },
        },
        layout: {
          padding: {
            right: 48,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
              scaleLabel: {
                display: !!this.xLabel,
                labelString: this.xLabel,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
                offsetGridLines: false,
              },
              scaleLabel: {
                display: !!this.yLabel,
                labelString: this.yLabel,
              },
            },
          ],
        },
      }

      return merge(defaultOptions, this.options)
    },
  },
  mounted() {
    if (this.barLabel) {
      this.addPlugin(ChartJSPluginDatalabels)
    }

    if (this.referenceDatasets.length) {
      const referenceDatasets = this.referenceDatasets

      this.addPlugin({
        afterDraw(chart) {
          const xScale = chart.scales['x-axis-0']
          const chartArea = chart.chartArea

          if (!xScale || !chartArea) {
            return
          }

          const ctx = chart.chart.ctx

          referenceDatasets.forEach((dataset) => {
            const values = [...new Set(dataset.data)].filter((value) => value !== null)

            values.forEach((value) => {
              const x = xScale.getPixelForValue(value)

              ctx.save()
              ctx.beginPath()
              ctx.moveTo(x, chartArea.top)
              ctx.lineTo(x, chartArea.bottom)
              ctx.lineWidth = dataset.borderWidth || 2
              ctx.strokeStyle = dataset.borderColor || dataset.backgroundColor || '#1C74DA'
              ctx.stroke()
              ctx.restore()
            })
          })
        },
      })
    }

    this.renderChart(this.computedData, this.computedOptions)
  },
}
</script>
